module.exports = __webpack_public_path__ + "static/media/header.2dc79379.jpeg";